import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { isEmpty } from "lodash";
import { push } from "store/actions/router";
import { FiGrid } from "react-icons/fi";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { groupCreationShow } from "actions/groupCreationActions";
import { getAllPortfolios } from "actions/portfolioActions";

import Accordian from "./Accordian";
import { hasAddedGroups } from "store/selectors/employer";
import { updateProgressiveOnboarding } from "actions/employerActions";
import Button from "components/Button";
import { createLoadingSelector } from "store/selectors";
import { employerConstants } from "actions/types";
import { progressiveOnboardingEvents } from "statics/states";
import type { RootState } from "types/state";

const isLoadingSelector = createLoadingSelector(
  employerConstants.UPDATE_PROGRESSIVE_ONBOARDING
);

const mapStateToProps = (state: RootState) => {
  return {
    userHasGroup: !isEmpty(state.employer.groups),
    hasAddedGroups: hasAddedGroups(state),
    isLoading: isLoadingSelector(state),
  };
};

const mapDispatchToProps = {
  getAllPortfolios,
  groupCreationShow,
  updateProgressiveOnboarding,
  push,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  isLocked?: boolean;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

class AddGroupCard extends React.PureComponent<Props> {
  _finishAddingGroups = () => {
    // @ts-expect-error preserved pre-existing call: updateProgressiveOnboarding
    // requires (client, eventName, companyId) but is invoked here with only two
    // args — companyId is undefined at runtime. Faithful to original JS behavior.
    return this.props.updateProgressiveOnboarding(
      this.props.client as ApolloClient<object>,
      progressiveOnboardingEvents.AddGroups
    );
  };

  render() {
    const { isLocked, userHasGroup } = this.props;

    let activeStepNumber = 1;
    let onClick: typeof this.props.groupCreationShow | null =
      this.props.groupCreationShow;

    if (userHasGroup) {
      activeStepNumber = 2;
      onClick = null;
    }

    const steps = [
      { index: 1, label: "Add initial payroll group" },
      {
        index: 2,
        label: "Add additional payroll groups",
        actions: [
          <Button
            key={"group-create"}
            size="sm"
            color="action"
            name="action"
            onClick={this.props.groupCreationShow}
          >
            Add Another Group
          </Button>,
          <Button
            key={"group-finished"}
            size="sm"
            name="action"
            onClick={this._finishAddingGroups}
            loading={this.props.isLoading}
          >
            Done
          </Button>,
        ],
      },
    ];

    return (
      <>
        <Accordian
          // @ts-expect-error Accordian's onClick type (from PropTypes) omits the
          // null the component accepts and guards at runtime (disabled ? noop :
          // onClick); preserved faithfully — resolves when Accordian's prop widens.
          onClick={onClick}
          icon={<FiGrid color="white" stroke="#60A4BF" size={16} />}
          title={"Group Setup"}
          description={
            "Configure employee groups, classifications, and pay periods."
          }
          actionText={"Add Group"}
          disabled={isLocked}
          completedAction={this.props.hasAddedGroups}
          activeStepNumber={activeStepNumber}
          steps={steps}
        />
      </>
    );
  }
}

export default connector(withApollo<Props>(AddGroupCard));
